// src/lib/config.ts
const VITE_BASE = (import.meta.env.VITE_BASE || '/').replace(/\/\/+$/,'/');
const VITE_API_BASE = (import.meta.env.VITE_API_BASE || '/api').replace(/\/\/+$/,'/');
const VITE_WS_BASE  = (import.meta.env.VITE_WS_BASE  || '/ws').replace(/\/\/+$/,'/');
const VITE_ORIGIN   = (import.meta.env.VITE_ORIGIN   || '').trim();

export const BASE = VITE_BASE;             // '/', '/event/', ...
export const API_BASE = VITE_API_BASE;     // '/api' или '/event/api'
export const WS_BASE  = VITE_WS_BASE;      // '/ws'  или '/event/ws'
export const ORIGIN   = VITE_ORIGIN || (typeof location !== 'undefined' ? location.origin : '');

export function withBase(p: string) {
  if (!p.startsWith('/')) p = '/' + p;
  if (BASE === '/') return p;
  return (BASE.replace(/\/$/,'') + p).replace(/\/+$/,'/');
}

export function httpURL(path: string) {
  if (!path.startsWith('/')) path = '/' + path;
  if (/^https?:\/\//i.test(API_BASE)) return API_BASE.replace(/\/$/,'') + path;
  return API_BASE.replace(/\/$/,'') + path;
}

export function wsURL() {
  if (/^wss?:\/\//i.test(WS_BASE)) return WS_BASE; // абсолютный ws(s) URL — используем как есть
  const origin = ORIGIN || (typeof location !== 'undefined' ? location.origin : 'http://localhost:3000');
  const u = new URL(origin);
  u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
  const path = WS_BASE.startsWith('/') ? WS_BASE : `/${WS_BASE}`;
  return `${u.protocol}//${u.host}${path}`;
}